import React from "react";

import { QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";
import reportWebVitals from "reportWebVitals";
import { ThemeProvider } from "styled-components";

import App from "app/App";
import { queryClient } from "app/queryClient";
import { theme } from "styles/theme";

import "index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </QueryClientProvider>
  // {/* </React.StrictMode> */}
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
